import type { Constructor } from '@whispli/types'
import { instanceToPlain } from '@whispli/client/tenant/openapi/utils'
import type { ClassTransformOptions } from 'class-transformer'

type OPTIONS_ARG = ClassTransformOptions | string

const OPTION_DEFAULTS = { groups: [ 'client' ] }

export const withObject = <T extends Constructor>(
  /** The super class to extend */
  SuperClass: T
) => class WithObject extends SuperClass implements WithObject {
  toJSON(options: OPTIONS_ARG = OPTION_DEFAULTS) {
    /** @note JSON.stringify can call this with a string key arg. Use defaults in this case */
    const _options = typeof options === 'string' ?
      OPTION_DEFAULTS :
      options

    return instanceToPlain(this, _options)
  }
}
